import { DefaultSiteData } from "components/WebDesigner/Data/SiteData";
import { SiteStyling } from "vagaro-website-rendering/src/components/Definitions/SiteStyling";
import { GetSetItemDetails, SetType } from "./SetLibraryAPI";
import { UserContext } from "vagaro-website-rendering/src/components/Definitions/UserContext";
import { setNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { attributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";

export const setStyleDenotation = "fci-";

export async function CreateSiteStylingFromString( userContext:UserContext,url:string,onComplete:(styling:SiteStyling)=>void, onError:(error:string)=>void,existingStyle:SiteStyling|null = null){

    //parseformat = 'set-123-3232-332;    

    let string = "";
    let urlSplit = url.split("/");

    for(let i = 0;i<urlSplit.length;i++){
        if(urlSplit[i].startsWith(setStyleDenotation)){
            string = urlSplit[i];
            break;
        }
    }
    let split = string.split("-");
    if(split.length < 4){
        onError("Invalid format");
        return;
    }

    let fontId = split[1];
    let colorId = split[2];
    let imageId = split[3];

    let setResultData:{
        fontData:any,
        colorData:any,
        imageData:any,
        hasErrored:boolean
    }  = {
        fontData:null,
        colorData:null,
        imageData:null,
        hasErrored:false
    }

    let promiseList = [];


    promiseList.push(GetSetItemDetails(userContext,SetType.Font,fontId,(data)=>{setResultData.fontData = data},(error)=>{setResultData.hasErrored = true}));
    promiseList.push(GetSetItemDetails(userContext,SetType.Color,colorId,(data)=>{setResultData.colorData = data},(error)=>{setResultData.hasErrored = true}));
    promiseList.push(GetSetItemDetails(userContext,SetType.Image,imageId,(data)=>{setResultData.imageData = data},(error)=>{setResultData.hasErrored = true}));

    await Promise.all(promiseList);

    if(setResultData.hasErrored){
        onError("Error fetching data");
        return;
    }
    let styling = existingStyle?? {...DefaultSiteData.siteStyling}
    let fontContent = [];
    let colorContent = [];
    let imageContent = [];
    try{
        fontContent = JSON.parse(setResultData?.fontData?.data?.data?.content??"[]");
        colorContent = JSON.parse(setResultData?.colorData?.data?.data?.content??"[]");
        imageContent = JSON.parse(setResultData?.imageData?.data?.data?.content??"[]");

    }
    catch{
        onError("Error parsing data");
        return;
    }
    if(fontContent.length < 2 || colorContent.length < 5 || imageContent.length < 4){
        onError("Invalid data");
        return;
    }

    setNodeStyleAttributeValue(styling.buttonPrimary,ScreenSize.Desktop,attributeTypes.borderRadius,"5px");
    setNodeStyleAttributeValue(styling.buttonSecondary,ScreenSize.Desktop,attributeTypes.borderRadius,"5px");
    setNodeStyleAttributeValue(styling.buttonTertiary,ScreenSize.Desktop,attributeTypes.borderRadius,"5px");
    //font
    styling.fontPrimary = fontContent[0];
    styling.fontSecondary = fontContent[1];
    //color
    ;
    styling.colorPallet = [...styling.colorPallet];
    for(let i = 0;i<colorContent.length;i++){
        styling.colorPallet[i] = colorContent[i];
    }
    //image
    styling.imageMapping = imageContent;
    userContext.imageMapping = imageContent;
    
    
    onComplete( styling);
}


export function CreateSiteStylingFromSetData(fontContent:string[],colorContent:string[],imageContent:string[],existingStyle:SiteStyling|null = null):SiteStyling{
    let styling = existingStyle?? {...DefaultSiteData.siteStyling}
    
    styling.fontPrimary = fontContent[0];
    styling.fontSecondary = fontContent[1];
    setNodeStyleAttributeValue(styling.buttonPrimary,ScreenSize.Desktop,attributeTypes.borderRadius,"5px");
    setNodeStyleAttributeValue(styling.buttonSecondary,ScreenSize.Desktop,attributeTypes.borderRadius,"5px");
    setNodeStyleAttributeValue(styling.buttonTertiary,ScreenSize.Desktop,attributeTypes.borderRadius,"5px");
    //color
    ;
    styling.colorPallet = [...styling.colorPallet];
    for(let i = 0;i<colorContent.length;i++){
        styling.colorPallet[i] = colorContent[i];
    }
    //image
    styling.imageMapping = imageContent;

    return styling;
}